export default __webpack_public_path__ + "static/media/BpmForce.29aafbd891c24c4ae8a448aecf64e092.webp";